class PaymentRequestButtonController {

  constructor(paymentGatewayService, paymentTokenService) {
    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
  }

  $onInit () {
    if (!this.gateway) {
      return this.handleError([ 'Please contact us for help.' ], 'No gateway set up.');
    }

    return this.paymentGatewayService.mount(this.gateway)
      .then(response => {
        return this.paymentTokenService.generatePaymentButtonToken(response.createPaymentRequestButton, this.paymentConfig)
          .then(token => {
            return this.handleSuccess(token);
          });
      })
      .catch(() => {
        this.handleError([ 'Please contact us for help.' ], 'Fail setting up payment request button');
      });
  }

  handleError (error, report) {
    this.errorCallback({ error, report });
  }

  handleSuccess(token) {
    if (token) {
      if(token.paymentMethod) {
        let response = {
          timestamp: this.paymentTokenService.getExpiryTimestamp(5),
          token: token.paymentMethod.id,
          customer: {
            first_name: '',
            last_name: '',
            phone: token.payerPhone || '',
            email: token.payerEmail || ''
          },
          card: token.paymentMethod.card || {}
        };

        if (token.payerName) {
          const customerName = token.payerName.split(' ');
          response.customer.first_name = customerName.shift();
          if (customerName.length > 0) {
            response.customer.last_name = customerName.join(' ');
          } else {
            response.customer.last_name = response.customer.first_name;
          }
        }

        return this.successCallback({ response });
      }

      this.handleError([ 'Sorry, there was a problem, please try again.' ]);
    }
  }
}

PaymentRequestButtonController.$inject = [ 'paymentGatewayService', 'paymentTokenService' ];

export default PaymentRequestButtonController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/controllers/payment.requestButton.controller.js